"use client";
import { Box } from "@mui/material";
import { Button, Link } from "gatsby-theme-material-ui";
import React from "react";
import slugify from "@sindresorhus/slugify";
import { useAllMenuItems } from "../helpers/useAllMenuItems";

export const MenuItemsList = ({ sx }) => {
  const { allMenuItems } = useAllMenuItems();
  return (
    <Box sx={{ ...sx }}>
      {allMenuItems.group.map(({ fieldValue }) => {
        return (
          <Button
            variant={"outlined"}
            disableElevation
            size="small"
            to={`/${slugify(fieldValue)}`}
            sx={{
              mr: 1,
              color: (theme) => theme.palette.grey[800],
              borderColor: (theme) => theme.palette.grey[800],
            }}
          >
            {fieldValue}
          </Button>
        );
      })}
    </Box>
  );
};
